import { SettingsSections } from "@payezy/auth";
import { Alert, Button, PageHeader } from "@payezy/ui";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { kratos } from "../lib/api";
import { useMe } from "../lib/org";

export function SecurityPage() {
  const me = useMe();
  if (me.session.impersonation) {
    return (
      <div className="mx-auto max-w-2xl px-6 py-10">
        <Alert tone="warning">Security settings are not available in staff view-as sessions.</Alert>
      </div>
    );
  }
  return (
    <div className="mx-auto max-w-2xl px-6 py-10">
      <Link to="/"><Button variant="ghost" size="sm" className="mb-4"><ArrowLeft className="size-4" /> Back</Button></Link>
      <PageHeader title="Security" description="Two-factor authentication is required to send payments, approve payments, and manage your team." />
      <SettingsSections kratos={kratos} returnTo={window.location.href} />
    </div>
  );
}
